import styled from "styled-components"

import { BORDER, SIZE, WHITESMOKE } from "../../const"

import { StyledSearch } from "../Search"

export const StyledHeader = styled.header`
  height: 49px;
  display: flex;
  padding: 25px 15px;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  border-bottom: ${BORDER};
  position: relative;

  .header_leftSide {
    display: flex;
  }

  .header_rightSide {
    display: flex;
    line-height: 25px;

    a {
      margin-right: 15px;
    }
  }

  .go-back-to-fcc-header{
    height: 50px;
    position: relative;
  }

  .header_rightSideMob {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    .searchBlock {
      width: auto;
      height: auto;
    }
    @media ${SIZE.mobileL} {
      .searchBlock {
        position: absolute;
        top: 101%;
        left: 0;
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        background: ${WHITESMOKE};
        padding: 10px 15px;
        z-index: 10;
      }
    }
    .menu_btn {
      top: 0;
      margin: 0 5px;
    }

    a {
      margin: 0 5px;
    }
    img {
      margin: 0 5px;
    }
  }

  img {
    width: 15px;
    heigth: 15px;
  }

  input {
    margin-bottom: 0;
  }

  #menu_toggle {
    opacity: 0;
  }

  .menu_btn {
    display: flex;
    align-items: center;
    position: relative;
    top: -10px;
    width: 26px;
    height: 26px;
    cursor: pointer;
    z-index: 1;
  }

  .menu_btn > span,
  .menu_btn > span::before,
  .menu_btn > span::after {
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: #616161;
  }
  .menu_btn > span::before {
    content: "";
    top: -8px;
  }
  .menu_btn > span::after {
    content: "";
    top: 8px;
  }

  #menu_toggle:checked ~ .menu_btn > span {
    transform: rotate(45deg);
  }
  #menu_toggle:checked ~ .menu_btn > span::before {
    top: 0;
    transform: rotate(0);
  }
  #menu_toggle:checked ~ .menu_btn > span::after {
    top: 0;
    transform: rotate(90deg);
  }
  #menu_toggle:checked ~ .menu_box {
    visibility: visible;
    left: 0;
  }

  .menu_btn > span,
  .menu_btn > span::before,
  .menu_btn > span::after {
    transition-duration: 0.25s;
  }

  ${StyledSearch} {
    height: 30px;
    background-position: 10px center;
    background-size: 16px;
    padding: 0px 15px 0 30px;
  }
`

export const StyledHeaderImage = styled.div`
  width: 225px;
  height: 36px;
  background: url(${props => props.bg});
  background-size: contain;
  background-repeat: no-repeat;
`
export const StyledHeaderGoBackToFcc = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #f5f5f5;
  padding: 0 15px;
`